<template>
  <div>
    <v-card>
      <v-app-bar color="primary" dense elevation="0" class="white--text">
        <v-toolbar-title>TIME SLOTS</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu offset-y left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" dark>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="clearOpenSlots()">
              <v-list-item-title><v-icon left>mdi-trash-can-outline</v-icon>Delete all open slots</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
      <v-card-text class="ma-0 pa-0">
        <v-expansion-panels multiple>
          <v-expansion-panel v-for="(item, i) in timeSlotsGroupedByDate" :key="i">
            <v-expansion-panel-header>
              <div>
                {{ formatDateTime(i) }}
              </div>
              <v-spacer />
              <v-avatar size="20" color="success" style="flex: none" class="white--text me-2" v-if="getSlotTypeCount(item, 'AVAILABLE') > 0">
                {{ getSlotTypeCount(item, 'AVAILABLE') }}
              </v-avatar>
              <v-avatar size="20" color="primary" style="flex: none" class="white--text me-2" v-if="getSlotTypeCount(item, 'RESERVED_APP') > 0">
                {{ getSlotTypeCount(item, 'RESERVED_APP') }}
              </v-avatar>
              <v-avatar
                size="20"
                color="secondary"
                style="flex: none"
                class="white--text me-2"
                v-if="getSlotTypeCount(item, 'RESERVED_DASHBOARD') > 0"
              >
                {{ getSlotTypeCount(item, 'RESERVED_DASHBOARD') }}
              </v-avatar>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ma-0 pa-0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="">Duration</th>
                      <th class="text-left">Status</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="slot in item" :key="slot.id">
                      <td>{{ slot.duration }} minutes</td>
                      <td>
                        <v-chip small outlined :color="getSlotColor(slot.state)">{{ getSlotStateChip(slot.state) }}</v-chip>
                      </td>
                      <td style="text-align: right">
                        <v-btn
                          small
                          class="px-5"
                          color="success"
                          v-if="slot.state == 'AVAILABLE'"
                          @click="openBookingDialog(slot)"
                          :disabled="slot.loader"
                        >
                          <span v-if="slot.loader"> <v-progress-circular indeterminate :size="20" :width="2"></v-progress-circular> Updating </span>
                          <span v-else>Book</span>
                        </v-btn>
                        <v-btn small color="success" v-else disabled>Booked</v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <div class="pa-8 text-center title" v-if="!loadingSlots && !hasSlots">No open slots on this date at the selected location</div>
    </v-card>
    <template v-if="loadingSlots">
      <v-skeleton-loader
        v-for="(page, i) in 10"
        :key="'skeletonloader-' + i"
        type="list-item"
        ref="skeleton"
        class="mx-auto my-0"
      ></v-skeleton-loader>
    </template>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {};
  },
  computed: {
    hasSlots() {
      if (Object.keys(this.timeSlotsGroupedByDate).length > 0) return true;
      else return false;
    },
    selectedDate() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.selectedDate;
    },
    timeSlotsGroupedByDate() {
      if (this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.timeSlots.length > 0)
        return this.groupByTimeSlot(this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.timeSlots);
      else return {};
    },
    loadingSlots() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.loadingSlots;
    },
    selectedLocation() {
      return this.$store.state.appointmentsCalendarStore.locationSelected;
    }
  },
  watch: {
    selectedLocation(n, o) {
      if (n && n != o) this.getEntriesOnDate();
    }
  },
  created() {
    this.getEntriesOnDate();
  },
  methods: {
    getEntriesOnDate() {
      if (this.selectedDate) {
        this.$store.dispatch('appointmentsCalendarStore/getCalenderDaySlots', {
          minDate: this.selectedDate,
          maxDate: this.selectedDate,
          locationId: this.selectedLocation?.id ? this.selectedLocation.id : 1
        });
      }
    },
    formatDateTime(d) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').local().format('hh:mm A');
    },
    groupByTimeSlot(data) {
      let result = data
        .filter((item) => item.state == 'AVAILABLE')
        .reduce(function (r, a) {
          r[a.date] = r[a.date] || [];
          r[a.date].push(a);
          return r;
        }, Object.create(null));

      return result;
    },
    getSlotTypeCount(slots, type) {
      if (!slots) return;
      let items = slots.filter((slot) => {
        return slot.state == type;
      });
      return items.length;
    },

    getSlotStateChip(state) {
      if (state == 'AVAILABLE') {
        return 'Open';
      } else if (state == 'RESERVED_APP') {
        return 'App';
      } else if (state == 'RESERVED_DASHBOARD') {
        return 'Dashboard';
      }
    },
    getSlotColor(state) {
      if (state == 'AVAILABLE') {
        return 'success';
      } else if (state == 'RESERVED_APP') {
        return 'primary';
      } else if (state == 'RESERVED_DASHBOARD') {
        return 'secondary';
      }
    },
    openBookingDialog(slot) {
      this.$store.commit('appointmentsCalendarStore/SET_SELECTED_SLOT', slot);
      this.$store.commit('appointmentsCalendarStore/SET_SELECTED_DATE_TIME_APPOINTMENT', slot.date);
      this.$store.commit('appointmentsCalendarStore/SET_APPOINTMENT_BOOKING_DIALOG', true);
    },
    clearOpenSlots() {
      this.$store.commit('appointmentsCalendarStore/SET_CONFIRM_DELETE_SLOTS_DIALOG', true);
    }
  }
};
</script>

<style lang="scss">
</style>
